
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util';
    import url from '@/lib/url';
    import AbpBase from '@/lib/abpbase';
    import VWidget from '@/components/VWidget.vue';

    @Component({
        components: { VWidget }
    })
    export default class Documents extends AbpBase {
        entity: string = 'document';
        selected: any = null;
        folderName: string = '';
        openAll: boolean = false;
        fileData: any = null;
        fileName: any = null;
        //progress: number = 20;
        url: string = url;

        file: any = null;
        chunks: Array<any> = [];
        uploaded: number = 0;

        get loadingCategory() {
            return this.$store.state.category.loading;
        }

        get loading() {
            return this.$store.state.document.loading;
        }

        get uploading() {
            return this.$store.state.document.uploading;
        }

        get downloading() {
            return this.$store.state.document.downloading;
        }
                
        get documents() {
            return this.$store.state.document.list.filter(item => {
                return item.category_id == this.selected.id;
            });
        }

        get list() {
            return this.$store.state.category.list;            
        }
    
        get children() {
            if (this.selected == null) return [];
            let items = Util.extend(true, [], this.selected.children);

            this.documents.forEach(item => {
                items.push({
                    id: 10000 + item.id,
                    document_id: item.id,
                    file: true,
                    name: item.filename,
                    icon: this.getIcon(item.filetype),
                    color: this.getColor(item.filetype)
                });
            });

            return items;
        }

        get progress(): number {
            if (this.file == null) return 0;
            return Math.floor((this.uploaded * 100) / this.file.size);
        }

        getIcon(filetype) {
            if (filetype == 'pdf')
                return 'mdi-file-pdf-box'
            else if (filetype == 'xls' || filetype == 'xlsx')
                return 'mdi-microsoft-excel'
            else if (filetype == 'doc' || filetype == 'docx')
                return 'mdi-microsoft-word'
            else if (filetype == 'png' || filetype == 'jpg' || filetype == 'jpeg')
                return 'mdi-image'
            else if (filetype == 'avi')
                return 'movie'
            else if (filetype == 'mp4')
                return 'mdi-video'
            else 
                return 'mdi-file-outline'
        }

        getColor(filetype) {
            if (filetype == 'pdf')
                return 'error'
            else if (filetype == 'xls' || filetype == 'xlsx')
                return 'green darken-2'
            else if (filetype == 'doc' || filetype == 'docx')
                return 'light-blue darken-4'
            else if (filetype == 'png' || filetype == 'jpg' || filetype == 'jpeg')
                return 'teal'
            else if (filetype == 'avi')
                return 'blue darken-1'
            else if (filetype == 'mp4')
                return 'indigo'
            else
                return 'grey lighten-2'
        }

        changeFolder(item) {
            this.selected = item[0];
            if (this.selected != undefined)
                this.getDocuments(this.selected.id);
        }

        onFileChange(file) {
            if (file != null) {
                this.file = file;
                this.createChunks();
                //this.fileName = file.name;
                //let reader = new FileReader();
                //let vm = this;
                //reader.onload = (e) => {
                //    vm.fileData = (e as any).target.result;
                //};
                //reader.readAsDataURL(file);
            }
        }

        createChunks() {
            let size = 2048000, chunks = Math.ceil(this.file.size / size);

            for (let i = 0; i < chunks; i++) {
                this.chunks.push(this.file.slice(
                    i * size, Math.min(i * size + size, this.file.size), this.file.type
                ));
            }
        }

        async download(item) {
            await this.$store.dispatch({
                type: 'document/download',
                data: {
                    id: item.document_id,
                    filename: item.name
                }
            });
        }

        async deleteDocument(id) {
            this.$swal({
                title: '&iquest;Est&aacute; seguro?',
                html: 'Se eliminara el documento del almacenamiento y no se podra revertir',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, &iexcl;Eliminar!',
                cancelButtonText: '&iexcl;No!',
                cancelButtonColor: '#FF5252',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then(async (result) => {
                if (result.value) {
                    await this.$store.dispatch({
                        type: 'document/delete',
                        data: {
                            id: id
                        }
                    });
                    Util.abp.notify.success(this, 'El Documento ha sido eliminado!');
                }
            })
        }

        async uploadFile() {
            if (this.chunks.length > 0) {
                for (var i = 0; i < this.chunks.length; i++) {
                    let formData = new FormData();
                    formData.set('is_last', (this.chunks.length - 1 === i ? '1' : '0'));
                    formData.set('category_id', this.selected.id);
                    formData.set('file', this.chunks[i], `${this.file.name}.part`);

                    let result = await this.$store.dispatch({
                        type: 'document/upload',
                        data: formData
                    });

                    this.uploaded += this.chunks[i].size;
                }

                Util.abp.notify.success(this, 'El Documento ha sido Subido!');
                (this.$refs.fileInput as any).reset();
                this.chunks = [];
                this.uploaded = 0;
            }
        }

        async getDocuments(category) {
            await this.$store.dispatch({
                type: 'document/getAll',
                data: { category: category }
            });
        }

        async getpage() {
            await this.$store.dispatch({
                type: 'category/getAll'
            });
        }

        async mounted() {
            await this.getpage();
        }

        created() {

        }
    }